module.exports = __webpack_public_path__ + "img/silla.57f41ae8.jpg";